// extracted by mini-css-extract-plugin
export default {"variantTab":"X5qPw4oheF","variantTabSelected":"M13H_Rv3pq","variantName":"_3qRgIzfKF","variantImageUrl":"QI0FN4QyCu","ripple":"jerQgOZqBS"};